import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { LoadingProvider } from "./components/loading/LoadingProvider";
import { ModalProvider } from "./components/modal";


ReactDOM.render(
    <React.StrictMode>
        <ModalProvider>
            <LoadingProvider>
                <App/>
            </LoadingProvider>
        </ModalProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
